import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { Timeframe } from "interfaces/timeframes";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_AVAILABLE_TIMEFRAMES_" }
);

export interface ListAvailableTimeframesState extends IState {
  data: Timeframe[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: Timeframe[];
}

const INITIAL_STATE: ListAvailableTimeframesState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListAvailableTimeframesState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: ListAvailableTimeframesState,
  action: ISuccessListUnitsAction
) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListAvailableTimeframesState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listAvailableTimeframes = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListAvailableTimeframesTypes = Types;
export const ListAvailableTimeframesActions = Creators;
